import { Register } from "~/components";

export default () => (
	<div class="rias-content col-span-full">
		<h1 class="headline-lg">Register for Membership</h1>

		<p>This is the first step in becoming an Approved Certifier of Design.</p>

		<p>RIAS-regs currently approves:</p>
		<ul>
			<li>
				Certifiers of Design (Section 6 – Energy) Domestic of the Scottish Building
				Standards.
			</li>
			<li>
				Certifiers of Design (Section 6 – Energy) Non-domestic of the Scottish Building
				Standards, both standard and advanced.
			</li>
		</ul>

		<p>
			We also offer the option of CPD membership, which provides 12 hours of CPD content,
			regarding Section 6 – Energy of the Technical Standards and can in many cases count
			towards membership of one or both Schemes.
		</p>

		<p>Registering your interest consists of 3 steps:</p>

		<ol>
			<li>We will ask you to provide you name, contact and company details.</li>
			<li>
				RIAS-regs will then check your registration details, this may take up to a week to
				complete. You may pre-qualify to join the Scheme, if not we will ask for further
				details of your qualifications and experience - see the Membership Criteria webpage,
				which drops down below the ‘Membership’ tab above.
			</li>
			<li>
				Once your details have been verified, yYou will be informed by email that your
				interest has been registered whether or not we are able to invite you to subscribe
				to the Scheme or not.If so, on any future visits to{" "}
				<a href="https://rias-regs.co.uk">rias-regs.co.uk</a> you will be able access the
				site via your email address and our email one-time code system which negates the
				need for a password.
			</li>
		</ol>

		<Register />
	</div>
);
